<template>
    <v-client-table ref="filesTable" :data="files" :columns="columns" :options="options">
        <template slot="file_id" slot-scope="props">
            <span v-if="!props.row.download_only">
                <a :href="`/files/view/${props.row.file_id}`" target="_blank">View</a>&nbsp;|
            </span>
            <a :href="`/files/download/${props.row.file_id}`" target="_blank">Download</a>
            <span v-if="allowDelete && (props.row.user_id == $store.state.user.user_id || isManager)">
                |&nbsp;<a href="javascript:void(0)" @click="deleteFile(props.row)" class="text-danger">Delete</a>
            </span>
        </template>
        <template slot="file_name" slot-scope="props">
            <span v-if="props.row.file_icon"><i :class="`fa ${props.row.file_icon}`"></i>&nbsp;</span>
            <router-link :to="!props.row.download_only ? `/files/view/${props.row.file_id}` : `/files/download/${props.row.file_id}`" target="_blank">
                {{ props.row.file_name }}
            </router-link>
        </template>
        <template slot="user_id" slot-scope="props">
            {{ props.row.FirstName }} {{ props.row.LastName }}
        </template>
        <template slot="created_at" slot-scope="props">
            {{ props.row.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
        </template>
        <template slot="description" slot-scope="props">
            <template v-if="props.row.user_id == $store.state.user.user_id || isManager">
                <inline-edit :key="`desc-edit-${props.row.file_id}`" v-model="props.row.description" :url="`/files/edit-description/${props.row.file_id}`" />
            </template>
            <template v-else>
                {{ props.row.description }}
            </template>
        </template>
    </v-client-table>
</template>

<script>
    export default {
        props: {
            allowDelete: {
                type: Boolean,
                default: false,
            },
            files: {
                type: Array,
                required: true
            },
            columns: {
                type: Array,
                required: false,
                default: function() {
                    return ['file_id', 'file_name', 'user_id', 'created_at'];
                },
            },
            options: {
                type: Object,
                required: false,
                default: function() {
                    return {
                        headings: {
                            file_id: 'Actions',
                            file_name: 'File Name',
                            user_id: 'Uploader',
                            created_at: 'Uploaded Date',
                        },
                        perPageValues: [],
                        sortable: ['file_name', 'created_at'],
                        columnsDropdown: false,
                        uniqueKey: 'file_id',
                    };
                },
            },
        },

        data: function() {
            return {
                userTimezone: this.$store.state.user.timezone,
                isManager: this.$root.hasPermission('subcontractors.manage'),
            }
        },

        methods: {
            deleteFile(file){
                //Confirm with the user
                if(!confirm('Are you sure you want to delete file: '+file.file_name+'?'))
                {
                    return;
                }

                //Send it
                this.$http.post('/files/delete/'+file.file_id)
                    .then(res => {
                        //Alert the user
                        this.$toastr.success('File Deleted');

                        // Remove the file
                        for (var i = this.files.length - 1; i >= 0; i--)
                        {
                            //If the IDs match, replace it
                            if(this.files[i].file_id == file.file_id)
                            {
                                this.files.splice(i, 1);

                                //Stop here;
                                return;
                            }
                        }
                });
            },
        },

        mounted() {

        }
    }
</script>